export default __webpack_public_path__ + "img/fbf56d3bd8539897b5f3d3b8e822a741.svg";